import { Component } from '@angular/core';
import { HeroEmpresarialComponent } from '../../hero-empresarial/hero-empresarial.component';

@Component({
  selector: 'app-hero-psicologia-salud-mental',
  standalone: true,
  imports: [],
  templateUrl: '../../hero-empresarial/hero-empresarial.component.html',
  styleUrl: './hero-psicologia-salud-mental.component.css'
})
export class HeroPsicologiaSaludMentalComponent {
  name="Terapia Psicologíca y Salud Mental";
  description = "Profesionales que brindan apoyo emocional, prevención y tratamiento de problemas psicológicos a los empleados.";
  description2 = "Este servicio incluye el manejo del estrés, ansiedad, conflictos laborales y bienestar mental en general";
  routeLogo = "assets/img/enterprise/menu/psicologiaSaludMental.svg";
  routeImage = "assets/img/enterprise/hero/fotoTerapiaPsicologica.svg"
}
